import state from './flash.state'
import mutations from './flash.mutations'
import actions from './flash.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
